/* StatusComponent.js */

"use strict";

const BaseActivityViewColumnComponent = require("../BaseActivityViewColumnComponent");
const Renderer = require("./StatusRenderer");
const _ = require("lodash");

class StatusColumnComponent extends BaseActivityViewColumnComponent {
    constructor(activityEntity) {
        super(activityEntity);

        const normalizedActivity = this._normalizeActivity(activityEntity);

        this._status = _.get(normalizedActivity, "status", null);

        this._renderer = new Renderer(this);

        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/
    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer._shutdown().then(() => {
            this._renderer = undefined;
            this._status = undefined;
        });
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    setValue(newVal) {
        if (!_.isUndefined(newVal)) {
            this._status = newVal;
        } else {
            this._status = null;
        }
    }

    getValue() {
        return this._status;
    }

    static SortFunction(a, b) {
        let aVal = 0,
            bVal = 0;

        function getSatusIndexValue(sts) {
            let index;
            switch (sts) {
                case "clean":
                    index = 1;
                    break;
                case "queued":
                    index = 2;
                    break;
                case "loading":
                    index = 3;
                    break;
                case "cancelled":
                    index = 4;
                    break;
                case "error":
                    index = 5;
                    break;
                default:
                    index = 0;
                    break;
            }
            return index;
        }

        aVal = getSatusIndexValue(a[1]);
        bVal = getSatusIndexValue(b[1]);

        if (aVal > bVal) {
            return 1;
        }
        if (aVal < bVal) {
            return -1;
        }
        return 0;
    }

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}

module.exports = StatusColumnComponent;
